import { motion, useReducedMotion } from "motion/react";
import { useTranslation } from "react-i18next";

import { AppStoreBadges } from "../components/AppStoreBadges";
import { Container } from "../components/Container";

export function FinalCTA() {
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  const fadeUp = (delay = 0) =>
    reduce
      ? { initial: false }
      : {
          initial: { opacity: 0, y: 24 },
          whileInView: { opacity: 1, y: 0 },
          viewport: { once: true, margin: "-80px" },
          transition: { duration: 0.6, ease: "easeOut" as const, delay },
        };

  return (
    <section className="relative isolate overflow-hidden bg-brand-500 py-14 text-white sm:py-20">
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full opacity-[0.06]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="walker-pattern"
            x="0"
            y="0"
            width="120"
            height="120"
            patternUnits="userSpaceOnUse"
          >
            <g fill="#FFFFFF" transform="translate(40,30)">
              <circle cx="20" cy="6" r="5" />
              <rect x="17" y="13" width="6" height="11" rx="2" />
              <path d="M10 50 L17 24 L20 24 L20 30 L14 50 Z" />
              <path d="M30 50 L23 24 L20 24 L20 30 L26 50 Z" />
            </g>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#walker-pattern)" />
      </svg>

      <Container size="lg" className="relative text-center">
        <motion.h2
          {...fadeUp(0)}
          className="section-heading text-white"
          style={{ color: "#FFFFFF" }}
        >
          {t("final_cta.title")}
        </motion.h2>
        <motion.p
          {...fadeUp(0.08)}
          className="mx-auto mt-5 max-w-2xl text-lg text-white/85"
        >
          {t("final_cta.subtitle")}
        </motion.p>
        <motion.div
          {...fadeUp(0.16)}
          className="mt-10 flex flex-col items-center"
        >
          <AppStoreBadges />
        </motion.div>
      </Container>
    </section>
  );
}
